import classnames from 'classnames';
import React from 'react';

import { PopupBuilderRichTextContentSection } from '../contentTypes';
import { Div } from '../HTMLElement';
import { TextAlign } from '../interfaces';
import { buildSpacingClassNamesFromContent, buildVisibilityClassNamesFromContent, formatHtml } from '../util';
import { PropsWithCustomComponent, VariantsController } from '../VariantsController';

export interface PopupBuilderRichTextComponentProps extends PopupBuilderRichTextContentSection {}

const PopupBuilderRichTextComponent = ({ options, richText }: PopupBuilderRichTextComponentProps) => {
  const textAlign = options?.textAlign as TextAlign;
  const margin = options?.margin && buildSpacingClassNamesFromContent('m', options.margin);
  const visibility = options?.visibility;
  const visibilityClassNames = visibility && buildVisibilityClassNamesFromContent(visibility);

  return (
    <React.Fragment>
      {options?.enabled && (
        <Div
          className={classnames('popup-builder-rich-text-component', options.classes)}
          textAlign={textAlign}
          uiClassName={{ bs5: classnames(margin, visibilityClassNames) }}
        >
          {formatHtml(richText)}
        </Div>
      )}
    </React.Fragment>
  );
};

export type PopupBuilderRichTextComponentVariants = '';

const PopupBuilderRichTextComponentController = (
  props: PropsWithCustomComponent<PopupBuilderRichTextComponentProps>
) => (
  <VariantsController<PopupBuilderRichTextComponentProps, PopupBuilderRichTextComponentVariants>
    {...props}
    variantsControllerConfig={{
      defaultComponent: PopupBuilderRichTextComponent,
      name: 'PopupBuilderRichTextComponent',
    }}
  />
);
export { PopupBuilderRichTextComponentController as PopupBuilderRichTextComponent };
